
const Datatable_actions = {

}

export default Datatable_actions;
